module.exports = __webpack_public_path__ + "img/tower.847bd5e6.png";